import React from "react";
// import { v4 as uuid } from "uuid";
import {
  Card,
  // IconButton,
  MenuItem,
  Menu,
  // Tooltip,
  TextField,
  Divider,
  Button,
  Stack,
  Typography,
  Grid,
  InputLabel,
  TextareaAutosize,
  Alert,
  FormControl,
  Select,
  Box,
  // InputLabel,
} from "@common-ui/ui";
import { useDispatch, useSelector } from "react-redux";
import { AddCircle, DeleteForever } from "@mui/icons-material";
import {
  workInstructionSlice,
  ITEM_OPTIONS,
} from "../../../../reducers/workReducer";
import PassFail from "./PassFail";
import TaskItem from "./TaskItem";
// import { flatten } from "lodash";
import YesNo from "./YesNo";
import NewSubSection from "./SubSection";
import Custom from "./Custom";

const AddSubSection = ({
  options,
  selectedIndex,
  //   setSelectedIndex,
  handleClick,
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);
  const handleClickListItem = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (event, index) => {
    // setSelectedIndex(index);
    handleClick(index);
    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <p
      style={{
        padding: 16,
        border: "1px dashed #999999",
        // width: "100%",
        borderRadius: 10,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Button
        aria-expanded={open ? "true" : undefined}
        onClick={handleClickListItem}
        startIcon={<AddCircle />}
        sx={{ fontWeight: 200 }}
        size="small"
      >
        Add Another
      </Button>
      {/* <Tooltip title="Add">

        <IconButton
          // size="small"
          color="primary"
          aria-label="add task"
          //   sx={{ p: 0, ml: 2 }}
          component="span"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClickListItem}
        >
          <AddCircle />
        </IconButton>
      </Tooltip> */}
      <Menu
        id="lock-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "lock-button",
          role: "listbox",
        }}
      >
        {options.map((option, index) => (
          <MenuItem
            key={option}
            // disabled={index === 0}
            selected={index === selectedIndex}
            onClick={(event) => handleMenuItemClick(event, index)}
          >
            {option}
          </MenuItem>
        ))}
      </Menu>
    </p>
  );
};

const SubSection = ({
  subSection,
  handleRemoveSubSection,
  subSectionIndex,
  sectionIndex,
}) => {
  const dispatch = useDispatch();
  const steps = [];
  const section = useSelector((state) =>
    state.workInstruction.items.find((section, i) => i === sectionIndex)
  );
  Array.from(section.items).forEach((element, newIndex) => {
    const elementStep = `${steps.length + 1}`;
    if (!element.test_points || element.subName) {
      steps.push({ id: element.id, step: elementStep, nextSteps: [] });
      if (element.test_points) {
        Array.from(element.test_points).forEach((item, i) => {
          steps
            .find((element) => element.id === subSection.id)
            ?.nextSteps.push({
              id: item.id,
              step: `${elementStep}.${i + 1}`,
              nextSteps: [],
            });
        });
      } else {
        steps
          .find((element) => element.id === subSection.id)
          ?.nextSteps.push({
            id: element.id,
            step: `${elementStep}.1`,
            nextSteps: [],
          });
      }
    } else {
      Array.from(element.test_points).forEach((item, i) => {
        steps.push({ id: item.id, step: `${steps.length + 1}`, nextSteps: [] });
      });
    }
  });
  // console.log(steps);
  if (subSection.subType) {
    return (
      <NewSubSection
        subSection={subSection}
        sectionIndex={sectionIndex}
        subSectionIndex={subSectionIndex}
        handleRemoveSubSection={handleRemoveSubSection}
        steps={steps}
      />
    );
  }
  switch (subSection.type) {
    case "INSTRUCTION":
      return (
        <div>
          <span style={{ display: "flex", alignItems: "center" }}>
            <Typography sx={{ mr: 1 }}>
              {`${sectionIndex + 1}.${
                steps.find((element) => element.id === subSection.id).step
              }`}
            </Typography>
            {/* <Typography sx={{ mr: 1 }} variant="h4">
              {subSection?.name}
            </Typography> */}

            <Button
              onClick={() => handleRemoveSubSection(subSection.id)}
              startIcon={<DeleteForever />}
              sx={{ fontWeight: 200 }}
              size="small"
            >
              Remove
            </Button>
          </span>
          {/* <div>
            <InputLabel>Title</InputLabel>
            <TextField
              sx={{ mt: 1 }}
              size="small"
              fullWidth
              placeholder="Type"
              margin="normal"
              name="content"
              value={subSection.title}
              onChange={(e) =>
                dispatch(
                  workInstructionSlice.actions.updateSubSections({
                    sectionIndex,
                    subSectionIndex,
                    name: "title",
                    value: e.target.value,
                  })
                )
              }
            />
          </div> */}
          <Grid>
            <Grid item md={6} xs={12}>
              <div>
                <InputLabel>Info Panel</InputLabel>
                <FormControl fullWidth name="na">
                  <Select
                    sx={{ mt: 1 }}
                    onChange={(e) =>
                      dispatch(
                        workInstructionSlice.actions.updateSubSections({
                          sectionIndex,
                          subSectionIndex,
                          name: "infoPanel",
                          value: e.target.value,
                        })
                      )
                    }
                    size="small"
                    placeholder="Select"
                    name="infoPanel"
                    variant="outlined"
                    value={subSection.infoPanel}
                    // displayEmpty
                    // renderValue={() => "Select"}
                  >
                    <MenuItem value="none">
                      <em>None</em>
                    </MenuItem>
                    <MenuItem value={"Information"}>Information</MenuItem>
                    <MenuItem value={"Warning"}>Warning</MenuItem>
                    <MenuItem value={"Danger"}>Danger / Error</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </Grid>
            <Grid item md={6} xs={12}>
              {subSection.infoPanel === "Information" ? (
                <Alert sx={{ my: 2 }} severity="info">
                  Information
                </Alert>
              ) : subSection.infoPanel === "Warning" ? (
                <Alert sx={{ my: 2 }} severity="warning">
                  Warning
                </Alert>
              ) : subSection.infoPanel === "Danger" ? (
                <Alert sx={{ my: 2 }} severity="error">
                  Danger / Error
                </Alert>
              ) : (
                <Box sx={{ my: 1 }}></Box>
              )}
              {/* <div>{<InfoPanel key={subSection.infoPanel} />}</div> */}
            </Grid>
            <Grid item md={12} xs={12}>
              <div>
                <InputLabel>Instruction</InputLabel>
                <TextField
                  sx={{ mt: 1 }}
                  size="small"
                  fullWidth
                  placeholder="Type"
                  margin="normal"
                  InputProps={{
                    inputComponent: TextareaAutosize,
                    inputProps: { minRows: 4 },
                  }}
                  name="content"
                  value={subSection.content}
                  onChange={(e) =>
                    dispatch(
                      workInstructionSlice.actions.updateSubSections({
                        sectionIndex,
                        subSectionIndex,
                        name: "content",
                        value: e.target.value,
                      })
                    )
                  }
                />
              </div>
            </Grid>
          </Grid>
          {/* <div>Coming Soon!</div>  */}
          <Divider sx={{ my: 2 }} />
        </div>
      );
    case "PASS/FAIL":
      return (
        <PassFail
          subSection={subSection}
          sectionIndex={sectionIndex}
          subSectionIndex={subSectionIndex}
          handleRemoveSubSection={handleRemoveSubSection}
          steps={steps}
        />
      );
    case "CUSTOM":
      return (
        <Custom
          subSection={subSection}
          sectionIndex={sectionIndex}
          subSectionIndex={subSectionIndex}
          handleRemoveSubSection={handleRemoveSubSection}
          steps={steps}
        />
      );
    case "SUB-SECTION":
      return (
        <NewSubSection
          subSection={subSection}
          sectionIndex={sectionIndex}
          subSectionIndex={subSectionIndex}
          handleRemoveSubSection={handleRemoveSubSection}
          steps={steps}
        />
      );
    case "YES/NO":
      return (
        <YesNo
          subSection={subSection}
          sectionIndex={sectionIndex}
          subSectionIndex={subSectionIndex}
          handleRemoveSubSection={handleRemoveSubSection}
          steps={steps}
        />
      );
    case "TASK ITEM":
      return (
        <TaskItem
          subSection={subSection}
          sectionIndex={sectionIndex}
          subSectionIndex={subSectionIndex}
          handleRemoveSubSection={handleRemoveSubSection}
          steps={steps}
        />
      );
    default:
      return (
        <div>
          <span style={{ display: "flex", alignItems: "center" }}>
            <Typography sx={{ mr: 1 }}>
              {`${sectionIndex + 1}.${subSectionIndex + 1})`}
            </Typography>
            <Typography sx={{ mr: 1 }} variant="h4">
              {subSection?.name}
            </Typography>

            <Button
              onClick={() => handleRemoveSubSection(subSection.id)}
              startIcon={<DeleteForever />}
              variant="outlined"
            >
              Remove
            </Button>
          </span>
          <div>Coming Soon!</div> <Divider sx={{ my: 2 }} />
        </div>
      );
  }
};

const Section = ({ handleRemoveSection, sectionIndex, sectionId }) => {
  const section = useSelector((state) =>
    state.workInstruction.items.find((section) => section.id === sectionId)
  );
  // const options = ITEM_OPTIONS;
  const [selectedIndex, setSelectedIndex] = React.useState(-1);

  const dispatch = useDispatch();

  const handleClick = (item) => {
    dispatch(
      workInstructionSlice.actions.addSectionItem({
        sectionId: section.id,
        name: ITEM_OPTIONS[item],
      })
    );
    // setSubSections([...subSections, { name: options[item], id: uuid() }]);
  };
  const handleRemoveSubSection = (id) => {
    dispatch(
      workInstructionSlice.actions.removeSectionItem({
        sectionId: section.id,
        itemId: id,
      })
    );
  };
  return (
    <Card
      variant="outlined"
      sx={{
        p: 2,
        borderRadius: "10px",
        mb: 2,
      }}
    >
      <span style={{ display: "flex", alignItems: "center" }}>
        <Typography sx={{ mr: 1 }}>{sectionIndex + 1}</Typography>
        <InputLabel>Title</InputLabel>
      </span>

      <Stack direction="row" sx={{ alignItems: "center" }}>
        <TextField
          sx={{ mt: 1, mr: 1 }}
          size="small"
          autoComplete="off"
          fullWidth
          placeholder="Type"
          margin="normal"
          name="type"
          onChange={(e) =>
            dispatch(
              workInstructionSlice.actions.setSectionTitle({
                sectionId: section.id,
                title: e.target.value,
              })
            )
          }
          value={section.title}
          // variant="outlined"
        />
        <Button
          onClick={() => handleRemoveSection(section?.id)}
          startIcon={<DeleteForever />}
          size="small"
          sx={{ fontWeight: 200 }}
        >
          Remove
        </Button>
      </Stack>
      {Array.from(section.items).map((subSection, index) => {
        return (
          <SubSection
            key={subSection.id}
            subSection={subSection}
            subSectionIndex={index}
            sectionIndex={sectionIndex}
            handleRemoveSubSection={handleRemoveSubSection}
          />
        );
      })}
      <AddSubSection
        options={ITEM_OPTIONS}
        selectedIndex={selectedIndex}
        setSelectedIndex={setSelectedIndex}
        handleClick={handleClick}
      />
    </Card>
  );
};

export { Section };
